/**
 * Calculate the pure tone average vaulue with given threshold for the four frequencies
 *
 * @param audiogram Input single audiogram for the hearing device
 * @returns Returns the pure tone average value
 */
export function calcuatePureToneAverage(audiogram) {
    var weightings = [1, 2, 2, 1];
    var totalValue = audiogram.reduce(function (a, b, index) {
        return a + b * weightings[index];
    });
    var pureToneAverage = Math.round(totalValue / (6 * 5)) * 5;
    return pureToneAverage;
}
